import { selectedBeneficiarySchema } from 'BreetHelpers';
import * as yup from 'yup';

export type MANAGEAUTOSETTLEMENTACCOUNT = 'add-beneficiary' | 'auto-settlement' | 'manage-beneficiaries';

export const requestPaymentStageTitle: Record<MANAGEAUTOSETTLEMENTACCOUNT, string> = {
	'add-beneficiary': 'Add Bank Account',
	'auto-settlement': 'Automatic Settlement',
	'manage-beneficiaries': 'Manage Accounts',
};

export const autoSettlementSchema = yup.object({
	selectedBeneficiary: selectedBeneficiarySchema,
});

export type AutoSettlementType = yup.InferType<typeof autoSettlementSchema>;

export interface IAutoSettlementFormComponent {
	onAddNewBeneficiary: () => void;
	onManageBeneficiaries: () => void;
}
